import { Theme } from '../../types/types.js'
import { colors as lightColors } from './colors.light.js'

export const theme: Theme = {
  id: 'default',
  name: 'Default',
  colors: {
    light: lightColors,
    // TODO implement dark theme
    dark: lightColors,
  },
}
